import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutSharedService {
  private layoutLoadedSubject = new BehaviorSubject<boolean>(false);

  layoutLoaded$ = this.layoutLoadedSubject.asObservable();
  private userTeamsSource = new BehaviorSubject<any[]>([]);
  userTeams$ = this.userTeamsSource.asObservable();

  constructor() {}

  setLayoutLoaded(status: boolean): void {
    this.layoutLoadedSubject.next(status);
  }
  setUserTeams(teams: any[]) {
    this.userTeamsSource.next(teams);
  }
}